import { Injectable, inject } from '@angular/core';
import { ILogSirena, IListado, IQueryParam } from 'modelos/src';
import { Observable } from 'rxjs';
import { HelperService } from '../../auxiliares/servicios/helper.service';
import { HttpApiAdminService } from '../../auxiliares/servicios/http-api.service';

@Injectable({
  providedIn: 'root',
})
export class LogReenviosService {
  private http = inject(HttpApiAdminService);
  private helper = inject(HelperService);

  public getFiltered(
    queryParams?: IQueryParam,
  ): Observable<IListado<ILogSirena>> {
    const params = this.helper.getQueryParams(queryParams);
    return this.http.get(`/logreenvios`, { params });
  }

  public getById(id: string): Observable<ILogSirena> {
    return this.http.get(`/logreenvios/${id}`);
  }

  public delete(id: string): Observable<ILogSirena> {
    return this.http.delete(`/logreenvios/${id}`);
  }
}
